module.exports = __webpack_public_path__ + "static/media/Screenshot_3-thumb.c3002119.png";